import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';
import { CalendarIcon } from '../../components/svgs';
import AppLabel from '../app-label/app-label';
import { areEqual, validateEmail } from '../../util';
import 'react-toggle/style.css';
import { CustomToggle } from '../../components/shared';
import ReactDatePicker from 'react-datepicker';
import services from '../../services';
import { serviceOrganization } from '../../services/service-organization';
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import BtButton from '../bt-button/bt-button';
import './styles.css';
import ImagePreview from '../../components/shared/ImagePreview/ImagePreview';
import { FileScope } from '../../util/appEnum';
import Modal from '../../components/shared/Modal/Modal';
import TitleWrapper from '../../components/shared/TitleWrapper/TitleWrapper';
import StyledCheckbox from '../../components/shared/StyledCheckbox/StyledCheckbox';
import File from '../../components/File/File';
import { ReactComponent as InfoIcon } from '../../assets/svg/InfoIconLight.svg'
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import appState from '../../state/AppStateContainer';
import { format } from 'date-fns';
import Selector from '../../components/shared/Selector/Selector';
import { useTranslation } from 'react-i18next';

const emailProviders = [
  {value: 'DEFAULT', label: 'Default (Sendgrid)'},
  {value: 'SENDGRID', label: 'Sendgrid (US)'},
  {value: 'SENDINBLUE', label: 'Sendinblue (EU)'},
];

const credibilityData = [
  { value: 'syna', label: 'SYNA' },
  { value: 'creditsafe', label: 'Creditsafe' },
];

const AddOrganization = ({ onModalHide, saveOrg, editOrgData, show }) => {
  const [t] = useTranslation('organizations', { keyPrefix: 'add' });
  const [btnLoader, setBtnLoader] = useState(false);
  const [isActive, toggleIsActive] = useState(true);
  const [preApproveRecommendedSuppliers, setPreApproveRecommendedSuppliers] = useState(false);
  const [expiry, setExpiry] = useState(new Date());
  const [data, setData] = useState({
    kommun: '',
    organizationNumber: '',
    name: '',
    email: '',
    credibilityUser: '',
    credibilityNumber: '',
    creditsafeUser: '',
    creditsafePassword: '',
    isActive,
    preApproveRecommendedSuppliers,
    microsoftTenantId: '',
    emailDomain: '',
    logo: {},
    emailProvider: emailProviders[0],
    activeProducts: ['PURCHASING'],
    emailSuffixes: '',
    invoiceEmail: '',
    invoiceRef: '',
    salesOrgContract: null,
    onePlatformCompanyId: null
  });
  const [cities, setCities] = useState([]);
  const [formErrors, setFormErrors] = useState([]);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCities = async () => {
      const citiesData = await services.getCities();
      setCities(citiesData);
    };

    (async () => {
      const companies = await serviceOrganization.getOnePlatformCompanies();
      setCompanies(companies.map(company => ({
        label: `${company.companyName} ${company.fiscalId && `| ${company.fiscalId}`} (${company.companyId})`,
        value: company.companyId
      })));
      if (editOrgData) setOrgData();
    })()

    fetchCities();
  }, []);

  const setOrgData = () => {
    let _orgData = {
      kommun: _.isObject(editOrgData.kommun)
        ? editOrgData.kommun
        : { label: editOrgData.kommun, value: editOrgData.kommun },
      credibility: _.isObject(editOrgData.credibility)
        ? credibilityData.find(item => item.value === editOrgData.credibility.serviceName) ?? null
        : null,
      organizationNumber: editOrgData.organizationNumber,
      name: editOrgData.name,
      slug: editOrgData.slug,
      email: editOrgData.email,
      credibilityUser: _.isObject(editOrgData.credibility) ? editOrgData.credibility.user : '',
      credibilityNumber: _.isObject(editOrgData.credibility) ? editOrgData.credibility.number : '',
      creditsafeUser: editOrgData.credibility?.creditsafeUser || '',
      creditsafePassword: editOrgData.credibility?.creditsafePassword || '',
      microsoftTenantId: editOrgData.microsoftTenantId ?? '',
      emailDomain: editOrgData.emailDomain ?? '',
      customerType: editOrgData.customerType || '',
      invoiceEmail: editOrgData.invoiceEmail || '',
      invoiceRef: editOrgData.invoiceRef || '',
      logo: editOrgData.logo || {},
      salesOrgContract: editOrgData.salesOrgContract || null,
      emailProvider: editOrgData.emailProvider ? emailProviders.find(x=>x.value == editOrgData.emailProvider) : emailProviders[0],
      activeProducts: editOrgData.activeProducts ?? [],
      emailSuffixes: editOrgData.emailSuffixes ?? '',
      onePlatformCompanyId: editOrgData.onePlatformCompanyId ?? null,
      massMessaging: {
        ...editOrgData.massMessaging,
        singleMessageLimit: editOrgData.massMessaging?.singleMessageLimit ? editOrgData.massMessaging?.singleMessageLimit+'' : '',
        weeklyMessagesLimit: editOrgData.massMessaging?.weeklyMessagesLimit ? editOrgData.massMessaging?.weeklyMessagesLimit+'' : ''
      },
    };
    setData(_orgData);
    toggleIsActive(editOrgData.isActive);
    setPreApproveRecommendedSuppliers(editOrgData.preApproveRecommendedSuppliers);
    if (editOrgData?.expiry) setExpiry(new Date(editOrgData.expiry));
  };

  const onSaveOrganisation = async () => {
    setBtnLoader(!btnLoader);

    let formErrors = [];
    let formData = {
      name: '',
      kommun: '',
      organizationNumber: '',
      email: '',
      expiry: '',
      microsoftTenantId: '',
      emailDomain: '',
      logo: {},
      salesOrgContract: null,
      invoiceEmail: '',
      invoiceRef: '',
      activeProducts: [],
      emailSuffixes: '',
      onePlatformCompanyId: '',
      massMessaging: {},
    };
    if (data.credibility) {
      data.credibilityData = {
        serviceName: data.credibility.value,
        user: data.credibilityUser,
        number: data.credibilityNumber,
        creditsafeUser: data.creditsafeUser,
        creditsafePassword: data.creditsafePassword
      }
    }

    formData = Object.assign(formData, data);
    formData.expiry = expiry;
    if (data.emailProvider) {
      formData.emailProvider = data.emailProvider.value;
    }
    const fieldNames = {
      name: t('label.name', 'Företagsnamn'),
      kommun: t('label.municipality', 'Kommun'),
      organizationNumber: t('label.organizationNumber', 'Organisationsnummer'),
      email: t('label.email', 'Email'),
      invoiceEmail: t('label.invoiceEmail', 'E-postadress'),
      invoiceRef: t('label.invoiceRef', 'Referens'),
      salesOrgContract: t('label.contract', 'Avtal')
    };

    const optionalFields = ['isActive', 'preApproveRecommendedSuppliers', 'activeProducts', 'expiry', 'customerType', 'credibilityUser', 'credibilityNumber', 'creditsafeUser', 'creditsafePassword', 'credibility', 'microsoftTenantId', 'emailDomain', 'logo', 'emailProvider', 'emailSuffixes', 'onePlatformCompanyId', 'massMessaging'];
    if (!data.activeProducts?.includes('SALES')) {
      optionalFields.push('salesOrgContract');
      optionalFields.push('invoiceEmail');
      optionalFields.push('invoiceRef');
    }

    Object.entries(formData).forEach(([key, value]) => {
      if (
        !optionalFields.includes(key) &&
        !value ||
        (value instanceof Array && !value.length) ||
        (key === 'organizationNumber' && !value.length) ||
        (key === 'email' && validateEmail(value))
      ) {
        formErrors.push(fieldNames[key]);
      }
    });

    if (formErrors.length) {
      setFormErrors(formErrors);
      setBtnLoader(false);
      return;
    }

    try {
      if (editOrgData) {
        formData.organizationId = editOrgData._id;
        let updatedData = await serviceOrganization.updateOrganization({ ...formData });
        handleSuccessResponse(updatedData, t('notification.success.updated', 'Leverantören har uppdaterats'));
      } else {
        const org = await serviceOrganization.saveOrganization({ ...formData });
        formData._id = org._id;
        handleSuccessResponse(formData, t('notification.success.created', 'Leverantören har lagts till'));
      }
    } catch (e) {
      console.log(_.get(e, 'response.data.error'), '::::ERROR::::');
      handleErrorResponse(e);
    }
  };

  const handleSuccessResponse = (data, msg) => {
    NotificationManager.success(msg);
    setBtnLoader(false);
    saveOrg();
  };

  const handleErrorResponse = (error) => {
    setBtnLoader(false);
    NotificationManager.error(
      _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error })),
      t('notification.error.unexpected.title', 'Misslyckat')
    );
  };

  const getShortName = name => {
    if (name.includes('Elie')) {
      return 'Elie';
    } else if (name.includes('Jakob')) {
      return 'Jakob';
    } else if (name.includes('Nabaz')) {
      return 'Nabaz';
    } else if (name.includes('George')) {
      return 'George';
    }
  }

  const handleChange = (e) => {
    let _data = data;
    let name = e.target.name;
    let value = e.target.value;
    if (['massMessaging.singleMessageLimit', 'massMessaging.weeklyMessagesLimit'].includes(name)) {
      value = value.replaceAll(/\D/g, '');

      const numberValue = +value;
      if (numberValue > 9999) {
        const userName = getShortName(appState.getUserName());
        if (userName !== 'George') {
          NotificationManager.error(`WTF ${userName} 🫢... Are you trying to get us flagged? 🤔`);
        } else {
          NotificationManager.success(`Go ahead boss 😎`);
        }
      }

      if (_data.massMessaging) {
        _data.massMessaging[name.replace('massMessaging.', '')] = value;
      } else {
        _data.massMessaging = {
          [name.replace('massMessaging.', '')]: value,
        };
      }
    } else {
      _data[e.target.name] = value;
    }
    setData(prevState => ({ ...prevState, ..._data }));
  };

  const requiredValidator = key => {
    return formErrors.includes(key) ? <div className="error show">{t('validation.required', 'OBLIGATORISKT')}</div> : null;
  };

  const toggleStatus = () => {
    toggleIsActive(!isActive);
    handleChange({ target: { name: 'isActive', value: !isActive } });
  };

  const togglePreApproval = () => {
    const newValue = !preApproveRecommendedSuppliers;
    setPreApproveRecommendedSuppliers(newValue);
    handleChange({ target: { name: 'preApproveRecommendedSuppliers', value: newValue } });
  };

  const onChangeDropdown = (val, event) => {
    let _data = data || {};
    _data[event.name] = val;
    setData(prevState => ({ ...prevState, ..._data }));
  }

  const onOnePlatformCompanyIdChange = (value) => {
    setData(prevState => {
      const temp = {...prevState};
      temp.onePlatformCompanyId = value.value;
      return temp;
    });
  }

  const renderFormSlide = () => {
    const weeklyMessagesLog = Object.entries(data?.massMessaging?.messagesSentWeekly || {});
    const thisWeekInfo = (data?.massMessaging?.messagesSentWeekly || {})[format(new Date(), 'YYYY-ww', {useAdditionalWeekYearTokens: true,})];

    return (
      <div className="mx-content overflow-s custom-scrollbar" style={{fontSize: '14px'}}>
        <div className={'slide-1'} key="slide1">
          <AppLabel class="ar-label" headline={t('label.name', 'Företagsnamn')} required>
            <input
              className="ar-text-field"
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
            />
            {requiredValidator(t('label.name', 'Företagsnamn'))}
          </AppLabel>

          <AppLabel class="ar-label" headline={t('label.organizationNumber', 'Organisationsnummer')} required>
            <input
              className="ar-text-field"
              name="organizationNumber"
              value={data.organizationNumber}
              onChange={handleChange}
            />
            {requiredValidator(t('label.organizationNumber', 'Organisationsnummer'))}
          </AppLabel>

          <AppLabel headline={t('label.email', 'Email')} required class="ar-label">
            <input className={`ar-text-field ${editOrgData ? 'disabled' : ''}`} name="email" value={data.email} onChange={handleChange} disabled={!!editOrgData} />
            {requiredValidator(t('label.email', 'Email'))}
          </AppLabel>

          <AppLabel
            class="ar-label ar-select-label custom-ar-kommun-select"
            headline={t('label.county', 'Län')}
            required
          >
            <Select
              placeholder={t('placeholder.municipality', 'Välj')}
              options={cities.map(c => ({ value: c, label: c }))}
              className="c-autosuggest ar-select-field"
              value={data.kommun}
              name="kommun"
              onChange={onChangeDropdown}
              classNamePrefix="custom-dropdown-add-supp"
            />
            {requiredValidator(t('label.municipality', 'Kommun'))}
          </AppLabel>

          <AppLabel class="ar-label" headline={t('label.customerType', 'Kundtyp')}>
            <input
              className="ar-text-field"
              name="customerType"
              value={data.customerType}
              onChange={handleChange}
            />
          </AppLabel>

          <CustomToggle checked={isActive} onChange={toggleStatus} icons={false} label={t('label.active', 'Aktiv')} />

          <div style={{margin: '16px 0'}}>
            <span style={{color: 'var(--gray-700)', fontWeight: 500}}>{t('label.products', 'Produkter')}</span>
            <label style={{color: 'var(--gray-700)', display: 'flex', alignItems: 'center'}}><StyledCheckbox checked={data.activeProducts.includes('PURCHASING')} onChange={
              event => {
                const product = 'PURCHASING';
                setData(prevState => ({...prevState, activeProducts: [...prevState.activeProducts.filter(p => p != product), ...(event.target.checked ? [product] : [])]}))
              }
            } />{t('label.purchasing', 'Inköp')}</label>
            <label style={{color: 'var(--gray-700)', display: 'flex', alignItems: 'center'}}><StyledCheckbox checked={data.activeProducts.includes('SALES')} onChange={
              event => {
                const product = 'SALES';
                setData(prevState => ({...prevState, activeProducts: [...prevState.activeProducts.filter(p => p != product), ...(event.target.checked ? [product] : [])]}))
              }
            } />{t('label.sales', 'Försäljning')}</label>
          </div>

          {data.activeProducts.includes('SALES') && (
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '16px', borderBottom: '1px solid var(--gray-300)' }}>
              <label className="ar-label position-relative">{t('label.contract', 'Avtal')}</label>
              {data.salesOrgContract && (
                <div style={{ marginTop: '8px', marginBottom: '16px' }}>
                  <File
                    file={data.salesOrgContract?.file || data?.salesOrgContract?.name}
                    fileName={(data.salesOrgContract?.file ? data.salesOrgContract?.fileName : data.salesOrgContract?.name) ?? t('contract.fallbackFilename', 'Användaravtal.pdf')}
                    onRemove={() => { handleChange({target: {name: 'salesOrgContract', value: undefined}}); }}
                    blob={data.salesOrgContract?.file ? undefined : data.salesOrgContract}
                    scope={FileScope.SalesOrgContract}
                    scopeOptions={{ organizationNumber: data.organizationNumber }}
                  />
                </div>
              )}
              {!data.salesOrgContract && (
                <label style={{ width: 'fit-content' }}>
                  <input
                    type="file"
                    accept="application/pdf"
                    name="logo"
                    style={{ display: 'none' }}
                    onChange={(e) => { setData(prevState => ({ ...prevState, salesOrgContract: e.target.files[0] })); }}
                  />
                  <BtButton class="salesOrgContractButton" color="white" size="xxs" style={{ margin: 0, marginBottom: '16px', float: 'none', letterSpacing: 'normal' }}>
                    {t('button.uploadFile', 'Ladda upp fil')}
                  </BtButton>
                </label>
              )}
              {requiredValidator(t('label.contract', 'Avtal'))}

              <AppLabel class="ar-label" headline={t('label.invoiceEmail', 'E-postadress')}>
                <input
                  className="ar-text-field"
                  name="invoiceEmail"
                  value={data.invoiceEmail}
                  onChange={handleChange}
                />
                {requiredValidator(t('label.invoiceEmail', 'E-postadress'))}
              </AppLabel>

              <AppLabel class="ar-label" headline={t('label.invoiceRef', 'Referens')}>
                <input
                  className="ar-text-field"
                  name="invoiceRef"
                  value={data.invoiceRef}
                  onChange={handleChange}
                />
                {requiredValidator(t('label.invoiceRef', 'Referens'))}
              </AppLabel>
            </div>
          )}

          <AppLabel class="ar-label" headline={t('label.emailSuffixes', 'Visa endast förfrågningar till e-postadresser som slutar på')}>
            <p style={{textTransform: 'none', display: 'block', fontWeight: 400, color: 'var(--gray-700)', maxWidth: '512px'}}>
              {t('emailSuffixes.intro', 'Endast för försäljningsorganisationer för att filterera bort test/demo-förfrågningar. Separera olika adresser med komma t.ex. "@accurator.se, jakob@mailinator.com".')}
            </p>
            <input
              type="text"
              className="ar-text-field"
              name="emailSuffixes"
              value={data.emailSuffixes}
              autoComplete="off"
              onChange={handleChange}
              data-1p-ignore
            />
          </AppLabel>

          <AppLabel class="ar-label position-relative" headline={t('label.expirationDate', 'Avtalstid')}>
            <ReactDatePicker
              className="ar-text-field"
              value={expiry}
              selected={expiry}
              minDate={new Date()}
              popperPlacement="top-end"
              popperClassName="column-date-end-calendar-position-fix"
              onChange={date => setExpiry(date)}
              closeCalendar={true}
            />
            <CalendarIcon className="custom-style-calender"/>
          </AppLabel>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
            <span style={{ fontWeight: '500', color: 'var(--gray-700)' }}>{t('label.logo', 'Logotyp')}</span>
            <p style={{textTransform: 'none', display: 'block', fontWeight: 400, color: 'var(--gray-700)', maxWidth: '512px'}}>
              {t('logo.intro', 'Endast premiumkunder. 300 pixlar bred, transparent eller grå bakgrund.')}
            </p>
            <label style={{ width: 'fit-content' }}>
              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                name="logo"
                style={{ display: 'none' }}
                onChange={(e) => { setData(prevState => ({ ...prevState, logo: e.target.files[0] })); }}
              />
              {!(data?.logo?.fileName || data?.logo?.name) && (
                <BtButton color="white" size="xxs" style={{ margin: 0, float: 'none' }}>
                  <span style={{ margin: 0, letterSpacing: 'normal' }}>{t('button.uploadFile', 'Ladda upp fil')}</span>
                </BtButton>
              )}
            </label>
            {(data?.logo?.fileName || data?.logo?.name) && (
              <ImagePreview
                image={data?.logo}
                fileId={data?.logo?.file}
                scope={FileScope.OrganizationLogo}
                orgSlug={data?.slug}
                onRemove={() => setData(prevState => ({ ...prevState, logo: {}}))}
              />
            )}

            <TitleWrapper title={t('label.preApproveRecommendedSuppliers', 'Visa endast förhandsgodkända rekommenderade leverantörer')}>
              <CustomToggle checked={preApproveRecommendedSuppliers} onChange={togglePreApproval} icons={false}/>
            </TitleWrapper>

            <h3 className="inner-sec-title" style={{ width: '100%' }}>{t('title.massMessaging', 'Massutskick')}</h3>
            <div style={{ display: 'flex', gap: '16px', }}>
              <AppLabel class="ar-label" headline={t('label.singleMessageLimit', 'Max per utskick')} style={{ flex: '1 1 33%' }}>
                <input
                  className="ar-text-field massMessagingLimitField"
                  name="massMessaging.singleMessageLimit"
                  value={data.massMessaging?.singleMessageLimit || ''}
                  autoComplete="off"
                  onChange={handleChange}
                  placeholder="200"
                />
              </AppLabel>
              <AppLabel class="ar-label" headline={t('label.weeklyMessagesLimit', 'Max per vecka')} style={{ flex: '1 1 33%' }}>
                <input
                  className="ar-text-field massMessagingLimitField"
                  name="massMessaging.weeklyMessagesLimit"
                  value={data.massMessaging?.weeklyMessagesLimit || ''}
                  autoComplete="off"
                  onChange={handleChange}
                  placeholder="600"
                />
              </AppLabel>
              <AppLabel class="ar-label" headline={
                <div style={{ display: 'flex', gap: '8px' }}>
                  <div>
                    {t('label.sentPerWeek', 'Skickade per vecka')}
                  </div>
                  <TooltipContainer
                    renderReferenceComponent={(className, ref) => weeklyMessagesLog.length > 0 && <InfoIcon className={className} ref={ref} />}
                  >
                    {weeklyMessagesLog.length > 0 && (
                      <ul style={{ margin: 0, paddingLeft: '16px' }}>
                        {weeklyMessagesLog.map(([week, {amount, limit}]) => (
                          <li>{week}: {amount}/{limit}</li>
                        ))}
                      </ul>
                    )}
                  </TooltipContainer>
                </div>
              }>
                <div style={{ marginTop: '16px', textTransform: 'none' }}>{t('label.thisWeek', 'Denna vecka:')} {thisWeekInfo?.amount || 0}/{thisWeekInfo?.limit || data?.massMessaging?.weeklyMessagesLimit || 600}</div>
              </AppLabel>
            </div>
          </div>

          <h3 className="inner-sec-title">{t('title.addons', 'Tilläggstjänster')}</h3>

          <AppLabel class="ar-label" headline={t('label.microsoftTenantId', 'Microsoft Tenant ID')}>
            <input
              className="ar-text-field"
              name="microsoftTenantId"
              value={data.microsoftTenantId}
              autoComplete="off"
              onChange={handleChange}
            />
          </AppLabel>

          <AppLabel class="ar-label" headline={t('title.emailDomain', 'Email domain')}>
            <p style={{ color: 'var(--gray-500)', fontSize: '12px', whiteSpace: 'wrap', maxWidth: '512px', textTransform: 'none' }}>
              {t('emailDomain.intro', 'Enter the domain of the email addresses that users with sso will be using. Anyone with an email domain that does not match the one below will be treated as an external users (they can login with email and password).')}
            </p>
            <input
              className="ar-text-field"
              name="emailDomain"
              value={data.emailDomain}
              autoComplete="off"
              onChange={handleChange}
              placeholder="example.com"
            />
          </AppLabel>

          <AppLabel class="ar-label" headline={t('title.onePlatformCompanyID', 'One Platform Company ID')}>
            {!editOrgData && <p style={{ color: 'var(--gray-500)', fontSize: '12px', whiteSpace: 'wrap', maxWidth: '512px', textTransform: 'none' }}>
              {t('onePlatformCompanyID.intro', 'Välj vilket One Platform-företag som ska länkas till denna organisation. Om du inte väljer något kommer företaget med samma organisationsnummer länkas automatiskt (och om inget sådant företag finns kommer det att skapas).')}
            </p>}
            <Selector
              placeholder={t('placeholder.onePlatformCompanyID', 'Sök')}
              options={companies}
              name="onePlatformCompanyId"
              className="creditInfoSelector"
              value={data.onePlatformCompanyId ? companies.find(company => company.value === data.onePlatformCompanyId) : null}
              onChange={onOnePlatformCompanyIdChange}
              isClearable={true}
            />
          </AppLabel>

          <TitleWrapper title={t('label.credibility', 'Kreditinformation')}>
            <Select
              placeholder={t('placeholder.credibility', 'Välj')}
              options={credibilityData}
              name="credibility"
              className="creditInfoSelector"
              value={data.credibility}
              onChange={onChangeDropdown}
              isClearable={true}
            />
          </TitleWrapper>

          {data.credibility && renderCredibilityFields()}

          <TitleWrapper title={t('label.emailProvider', 'E-posttjänst')}>
            <Select
              placeholder={t('placeholder.emailProvider', 'Välj')}
              options={emailProviders}
              name="emailProvider"
              className="creditInfoSelector"
              value={data.emailProvider ?? emailProviders[0]}
              onChange={onChangeDropdown}
            />
          </TitleWrapper>
        </div>
      </div>
    );
  };

  const renderCredibilityFields = () => {
    return (
      <div className="credibility-fields">
        {
          data.credibility?.value === 'creditsafe' ? <>
            <AppLabel class="ar-label" headline={t('label.credibilityUser', 'Användarnamn')}>
              <input
                className="ar-text-field"
                name="creditsafeUser"
                value={data.creditsafeUser}
                onChange={handleChange}
              />
            </AppLabel>
            <AppLabel class="ar-label" headline={t('label.credibilityPassword', 'Lösenord')}>
              <input
                className="ar-text-field"
                name="creditsafePassword"
                value={data.creditsafePassword}
                onChange={handleChange}
              />
            </AppLabel>
          </> : <>
            <AppLabel class="ar-label" headline={t('label.credibilityUser', 'Användarnamn')}>
              <input
                className="ar-text-field"
                name="credibilityUser"
                value={data.credibilityUser}
                onChange={handleChange}
              />
            </AppLabel>
            <AppLabel class="ar-label" headline={t('label.credibilityNumber', 'Kundnummer')}>
              <input
                className="ar-text-field"
                name="credibilityNumber"
                value={data.credibilityNumber}
                onChange={handleChange}
              />
            </AppLabel>
          </>
        }
      </div>
    )
  }

  return (
    <Modal
      title={editOrgData ? t('pageTitle.edit', 'Redigera organisation') : t('pageTitle.create', 'Lägg till organisation')}
      show={show}
      setShow={onModalHide}
      buttonInfo={{
        label: editOrgData ? t('button.save', 'Spara') : t('button.add', 'Lägg till organisation'),
        action: onSaveOrganisation,
        loaderShow: btnLoader,
      }}
    >
      <div className="app-add-supplier app-create-project app-edit-supplier">
        <div className="page-paddings">
          <BtGrid>
            <BtRow>
              <BtColumn className="colum-left pp-col-left">
                <div className="content-left">{renderFormSlide()}</div>
              </BtColumn>
            </BtRow>
          </BtGrid>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(AddOrganization, areEqual);
